/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomerProgress } from './CustomerProgress';
import {
    CustomerProgressFromJSON,
    CustomerProgressFromJSONTyped,
    CustomerProgressToJSON,
} from './CustomerProgress';

/**
 * 
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    accessCode: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    apartmentNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    apartmentType: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDto
     */
    projectName: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    projectId: number;
    /**
     * 
     * @type {CustomerProgress}
     * @memberof CustomerDto
     */
    progress: CustomerProgress;
}

/**
 * Check if a given object implements the CustomerDto interface.
 */
export function instanceOfCustomerDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "accessCode" in value;
    isInstance = isInstance && "apartmentNumber" in value;
    isInstance = isInstance && "apartmentType" in value;
    isInstance = isInstance && "projectName" in value;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "progress" in value;

    return isInstance;
}

export function CustomerDtoFromJSON(json: any): CustomerDto {
    return CustomerDtoFromJSONTyped(json, false);
}

export function CustomerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'accessCode': json['accessCode'],
        'apartmentNumber': json['apartmentNumber'],
        'apartmentType': json['apartmentType'],
        'projectName': json['projectName'],
        'projectId': json['projectId'],
        'progress': CustomerProgressFromJSON(json['progress']),
    };
}

export function CustomerDtoToJSON(value?: CustomerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'accessCode': value.accessCode,
        'apartmentNumber': value.apartmentNumber,
        'apartmentType': value.apartmentType,
        'projectName': value.projectName,
        'projectId': value.projectId,
        'progress': CustomerProgressToJSON(value.progress),
    };
}

